import React, { useEffect, useState } from "react";
import { useGetPermissionsDocumentsQuery } from "../../../../../services/EndPointsApis";
import { log } from "console";
import DateComp from "../../../../../core/common/dateComponent/DateComp";

interface Folder {
  folderId: number;
  entityName: string;
  parentId: number | null;
  isFile: boolean;
  children: Folder[];
  isLocked: boolean; // Assuming `isLocked` is part of Folder interface
}

const ListViewDocumentPermissions = React.memo(({ setSelectedRowId, isMainModule, projectId, formikPermissions }: any) => {

  const [selectedFolderPath, setSelectedFolderPath] = useState<string | null>(null);

  const [folderCheckedState, setFolderCheckedState] = useState<any>({});

  const handleFolderSelection = (path: string, folderId: any, folderName: any) => {
    setSelectedFolderPath(path);
    setSelectedRowId(folderId);
  };

  const flattenFolders = (folder: Folder, parentPath: string = ""): any[] => {
    const currentPath = parentPath ? `${parentPath}` : `${folder.folderId}`;
    const flattened = [{ ...folder, path: currentPath }];

    if (!folder.isFile && folder?.children?.length > 0) {
      folder.children.forEach((child, index) => {
        const childPath = parentPath ? `${currentPath}.${index + 1}` : `${folder.folderId}.${index + 1}`;
        flattened.push(...flattenFolders(child, childPath));
      });
    }
    return flattened;
  };

  const flattenedFolders = formikPermissions?.values?.folderPermissionList?.map((folder: Folder, index: number) => flattenFolders(folder, `${index + 1}`))
    .flat() || [];

  const handleCheckboxChange = (folderId: number, isChecked: boolean) => {
    const newCheckedState = isChecked ?? !folderCheckedState[folderId];

    const updateFolders = (folders: Folder[]): Folder[] => {
      return folders.map((folder) => {
        if (folder.folderId === folderId) {
          return {
            ...folder,
            isLocked: newCheckedState,
            children: updateChildFolders(folder.children, newCheckedState),
          };
        }
        if (folder.children?.length > 0) {
          return { ...folder, children: updateFolders(folder.children) };
        }
        return folder;
      });
    };

    const updatedFolders = updateFolders(formikPermissions.values.folderPermissionList);

    formikPermissions.setFieldValue("folderPermissionList", updatedFolders);
    setFolderCheckedState((prevState: any) => ({
      ...prevState,
      [folderId]: newCheckedState,
    }));
  };

  const updateChildFolders = (children: Folder[], isChecked: boolean): Folder[] => {
    return children.map((child) => ({
      ...child,
      isLocked: isChecked,
      children: updateChildFolders(child.children || [], isChecked),
    }));
  };

  return (
    <div
      className="table-responsive mt-3"
      style={{ maxHeight: isMainModule ? '90vh' : '540px' }}
    >      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{  textAlign: "left" }}>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>File/Folder Name</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Permissions</th>
          </tr>
        </thead>
        <tbody>
          {flattenedFolders.map((folder: any) => (
            <tr
              key={folder.folderId}
              style={{
                // backgroundColor: selectedFolderPath === folder.path ? "#e6f7ff" : "transparent",
                cursor: "pointer",
              }}
              onClick={() => handleFolderSelection(folder.path, folder.folderId, folder.entityName)}
            >
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {folder.path}-{folder.entityName}
                {/* {folder.entityName} */}
              </td>
              <td className="text-center" style={{ border: "1px solid #ddd", padding: "8px" }}>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={folderCheckedState[folder.folderId] || folder.isLocked}
                  onChange={() => handleCheckboxChange(folder.folderId, !folderCheckedState[folder.folderId])}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default ListViewDocumentPermissions;
